import type { ArtAsset } from "@sins2-atlas/game-data";

/** Build the img src/srcSet for a dataset art asset. Art is served at /art/<name>.png with
 * <name>150.png / <name>200.png density variants; the asset's flags say which the game
 * ships, so the srcSet never references a file that does not exist. */
export function artSrc(asset: ArtAsset): { src: string; srcSet?: string } {
  const src = `/art/${asset.name}.png`;
  if (!asset.at150 && !asset.at200) return { src };
  const entries = [`${src} 1x`];
  if (asset.at150) entries.push(`/art/${asset.name}150.png 1.5x`);
  if (asset.at200) entries.push(`/art/${asset.name}200.png 2x`);
  return { src, srcSet: entries.join(", ") };
}
